import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { SortDataService } from './../../core/services/sortdata';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../core/models/messages';
import { CallOfferService } from './../../core/services/call-offer-service/call-offer.service';
import { EsnAppeloffreService } from './../../core/services/esn-appeloffre/esn-appeloffre.service';
import { EsnCandidatService } from './../../core/services/esn-candidat/esn-candidat.service';
import { SalarieService } from './../../core/services/salarie-service/salarie.service';
import { Country, IState, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { translations } from '../../core/models/call-offer';

@Component({
  selector: 'app-suggestioncallofferclientfinal',
  templateUrl: './suggestioncallofferclientfinal.component.html',
  styleUrls: ['./suggestioncallofferclientfinal.component.css'],
})
export class SuggestioncallofferclientfinalComponent {
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  Statut: { id: string; name: string }[] = [
    { id: '1', name: 'actif' },
    { id: '2', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  poste = [
    { id: 1, name: 'sur site' },
    { id: 2, name: 'à distance' },
    { id: 3, name: 'hybrid' },
  ];
  searchForm: FormGroup = this.createSearchForm();
  idoffre = this.activatedRoute.snapshot.params['id'];
  connectedUser = this.localStorageService.getData('userConnected');
  loadSpinner: boolean = false;
  idappel: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  sortAttr = '';
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  currentSortColumn: string = 'name';
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  applyForm: FormGroup = this.createForm();

  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  selectedUserId!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected: any;
  isCollapsed = true;
  iduser: any;
  listconsultant: any;
  skillsList: { name_FR: string }[] = [];
  listsuggestion: any;
  ischecked = true;
  selectedCandidats: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private appelofferservice: EsnAppeloffreService,
    private activatedRoute: ActivatedRoute,
    private candidatservice: EsnCandidatService,
    private callofferservice: CallOfferService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    (this.idclientConnected =
      this.localStorageService.getData('clientConnected')),
      (this.countries = Country.getAllCountries());
    this.getListSkills();
    this.getListsuggestion();
    this.getlistconsultant();
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;
      if (this.searchForm.dirty) {
        this.searchsuggestion();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        
        this.pagination = true
        this.getListsuggestion();
      }
    }
  }
  translateCountryName(name: string): string {
    
    return translations[name] || name;
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data.items.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  getListsuggestion() {
    let dataPyload =
      this.sortAttr == ''
        ? {
            client_id: this.idclientConnected,
            job_request_id: this.idoffre,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              client_id: this.idclientConnected,
              job_request_id: this.idoffre,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.callofferservice.getListsuggestion(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          console.log('response.data', response.data);
          this.listsuggestion = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
          console.log('list suggestion', this.listsuggestion);
        }
      },
      error: (error: any) => {
        console.error('Error fetching  job offer: ', error);
      },
    });
  }

  sortData(item: string) {
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    let sort = { sort: this.currentSortDirection, sortAttribute: item };
    this.sortAttr = item;
    console.log('sort', sort);
    if (this.searchForm.dirty)
      this.listsuggestion = this.sortDataService.sortArray(
        this.listsuggestion,
        item,
        this.currentSortDirection
      );
    else this.getListsuggestion();
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      desired_contract: [[], data?.desired_contract],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      current_country: [null, data?.current_country],
      mobility: [[], data?.mobility],
      availability: [[], data?.availability],
      date_start_candidature: ['', data?.date_start_candidature],
      date_end_candidature: ['', data?.date_end_candidature],
    });
  }

  /* search */
  searchsuggestion() {
    let valueForm = this.searchForm.value;
    let data = {
      name: valueForm.name,
      search: this.transformSearch(valueForm?.search),
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      years_of_experience: this.searchForm.value.years_of_experience,
      desired_contract: this.searchForm.value.desired_contract,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      availability: valueForm.availability,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      post_type: valueForm.post_type,
      current_country: valueForm.current_country
        ? valueForm.current_country
        : '',
      mobility: valueForm.city ? valueForm.mobility : '',
      date_start_candidature: valueForm.date_start_candidature,
      date_end_candidature: valueForm.date_end_candidature,
      per_page: this.itemsPerPage,
      page: this.currentPage,

      job_request_id: this.idoffre,
      client_id: this.idclientConnected,
    };
    console.log('data', data);

    this.callofferservice.searchsuggestion(data).subscribe({
      next: (resSearch) => {
        console.log('response searchhhhhhhhhh', resSearch);
        if ( this.currentPage > 1) {
          this.currentPage = 1;
          this.searchsuggestion();
          console.log('response search', resSearch);
        } else {
          this.listsuggestion = resSearch.data.data.slice(0, this.endIndex);
          console.log('response listsuggestion', this.listsuggestion);
          this.totalItems = resSearch.data.total;
          console.log('response totalItems', this.totalItems);
        }
      },
      error: (error) => {
        console.log(error);
        this.toastrService.error(serverError);
      },
    });
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchsuggestion();
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (this.ischecked) {
      if (type == 'single' && candidat) {
        if (candidat.cv || candidat.file_test) {
          if (typeFile && typeFile != '')
            candidat.file_test = candidat.file_test.split('/')[1];
          const fileUrl = !typeFile
            ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
            : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
          this.showGlobalSpinner();
          this.candidatservice.downloadPDF(fileUrl).subscribe(
            (data) => {
              const blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = !typeFile
                ? `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_CV.${candidat!.cv.split('.').pop()}`
                : `${candidat.ID_user}_${candidat.first_name}_${
                    candidat.last_name
                  }_QCM.${candidat!.file_test.split('.').pop()}`;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.hideGlobalSpinner();
            },
            () => {
              this.hideGlobalSpinner();
            }
          );
        } else {
          this.toastrService.info(EmptyCV);
        }
      } else if (this.selectedCandidats.length) {
        if (
          this.selectedCandidats.length == 1 &&
          !this.selectedCandidats[0].cv
        ) {
          this.toastrService.info(EmptyCV);
        } else this.downloadPdfFiles(typeFile);
      } else {
        this.toastrService.info(obligationSelect);
      }
    } else {
      this.toastrService.error(
        'Limite de téléchargements atteinte. Vous ne pouvez télécharger que 3 fichiers.'
      );
    }
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  isDateInFuture(): boolean {
    const availibilityDate = this.applyForm.get('availibility_date')?.value;
    const today = new Date();
    const availibility = new Date(availibilityDate);
    return availibility < today;
  }
  createForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [data ? data.availibility_date : ''],
      user_id: [data ? data.user_id : null],
    });
  }
  postuleroffre() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_request_id: this.idappel,
    };
    console.log('data', data);
    this.appelofferservice.applyJob(data).subscribe({
      next: (res: any) => {
        console.log('res', res);
        this.toastrService.success(
          'votre candidature a été envoyé avec succès.'
        );
      },
      error: (error) => {
        console.log(error.error.message);
        if (error.error.message === 'candidature already exist.') {
          this.toastrService.error('Candidature existe déjà');
        }
        if (error.error.message === 'the job offer has been deactivated.') {
          this.toastrService.error(
            "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
          );
        }
      },
    });
  }
  getlistconsultant() {
    console.log('nameEsn', this.nameEsn);
    this.appelofferservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
        this.listresponsablesWithDisplayName();
        console.log('list consultant by offre', this.listconsultant);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  listresponsablesWithDisplayName() {
    this.listconsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  open(suggestion: any) {
    console.log(suggestion);
    this.idappel = suggestion.id;
    console.log(this.idappel);
  }

  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;

      console.log('Selected user id:', this.selectedUserId);

      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    } else {
      // La case est décochée, vous pouvez ajouter un code supplémentaire si nécessaire
      console.log('Checkbox unchecked');
    }
  }
  deselectOtherCheckboxes(currentUserId: string) {
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }
  profilCandidatNavigation(id: any) {
    this.router.navigate(['/profil-candidats-anonyme/', +id]);
  }
}
